import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useMemo, useState } from "react"


const cardStyle = 'p-3 w-full flex flex-col gap-3 items-center bg-[#0D2436]'
const DesktopHowItWorks = () => {

    const [index, setIndex] = useState(0)

    const content = useMemo(() => ([
        <div className={`${cardStyle}`}>
            <img
                src="https://assets.learntube.ai/files/New%20Landing%20Page/thumbsup.svg?updatedAt=1744185899171"
                width={21}
                height={21}
                alt=""
                className="mx-auto"
            />
            <div className="leading-[130%]">
                <p>Gain</p>
                <p>Recognition</p>
            </div>
        </div>,
        <div className={`${cardStyle}`}>
            <img
                src="https://assets.learntube.ai/files/New%20Landing%20Page/increase-salary.svg?updatedAt=1744179161219"
                width={16}
                height={21}
                alt=""
                className="mx-auto"
            />
            <div className="leading-[130%] mt-2">
                <p>Increase Salary</p>
                <p className="text-white font-bold">up to 150%</p>
            </div>
        </div>,
        <div className={`${cardStyle}`}>
            <img
                src="https://assets.learntube.ai/files/New%20Landing%20Page/job-chance.svg?updatedAt=1744186634910"
                width={18}
                height={21}
                alt=""
            />
            <div className="leading-[130%]">
                <p><span className="text-white font-bold">3x</span> your Job</p>
                <p>Chances</p>
            </div>
        </div>,
        <div className={`${cardStyle}`}>
            <img
                src="https://assets.learntube.ai/files/New%20Landing%20Page/Group_3.svg?updatedAt=1744186835820"
                width={21}
                height={21}
                alt=""
            />
            <div className="leading-[130%]">
                <p>Get Noticed by</p>
                <p>Employers</p>
            </div>
        </div>
    ]), [])

    useEffect(() => {
        const interval = setInterval(() => {
          setIndex(prev => (prev + 1) % content.length)
        }, 4000)
        return () => clearInterval(interval)
    }, [content.length])
    

    return (
        <div className='mt-4 bg-[#0D2436] h-[164px] overflow-clip py-8 rounded-3xl flex items-center justify-center gap-[40px] px-4 pl-6'>
            <h2 className='text-2xl font-semibold text-[#D5EDFF] text-left' style={{
                textShadow: '0px 0px 3px rgba(255, 255, 255, 0.4)'
            }}>How it Works?</h2>
            <div className='flex items-center gap-6'>
                <div className="flex items-center relative z-20">
                    <div className="w-[136px] h-[136px] bg-[#0E4771] border-[6px] border-[#006FBC]/20 rounded-full flex flex-col items-center justify-center px-2 text-[#83BEFF] text-[15px]">
                        <img src="https://assets.learntube.ai/files/New%20Landing%20Page/Quiz%201.svg?updatedAt=1744179014975" width={31.5} height={31.5} alt=""/>
                        <p>Pass a Quick</p>
                        <p>Test</p>
                    </div>
                </div>
                <div className='flex items-center justify-center relative'>
                    <img
                        src="https://assets.learntube.ai/files/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
                        width={18}
                        height={21}
                        className="-rotate-90 z-20"
                        alt=""
                    />
                    <div className="flex-shrink-0 w-[156px] h-[156px] px-1 bg-[#08578F] border-[10px] border-[#006FBC]/20 rounded-full flex flex-col items-center justify-center text-[#83BEFF] text-[15px] z-20">
                        <img
                            src="https://assets.learntube.ai/files/New%20Landing%20Page/Certificate%201.svg?updatedAt=1744181188447"
                            width={33}
                            height={31.5}
                            alt=""
                        />
                        <p className="mt-3">Unlock Instant</p>
                        <p>Certificate</p>
                    </div>
                    <img
                        src="https://assets.learntube.ai/files/New%20Landing%20Page/down-arrow.svg?updatedAt=1744184923146"
                        width={18}
                        height={21}
                        className="-rotate-90 z-20"
                        alt=""
                    />
                    <div className='w-[228px] h-[226.5px] absolute z-0 left-1/2 -translate-x-1/2'>
                        <motion.img 
                            src="https://assets.learntube.ai/files/New%20Landing%20Page/Group%2022973.png?updatedAt=1744727963291" 
                            className="w-full h-full" 
                            alt=""
                            animate={{ rotate: -360 }}
                            transition={{
                                repeat: Infinity,
                                duration: 12,
                                ease: "linear"
                            }}
                        />
                    </div>
                    <div className='w-[364px] h-[364.5px] absolute z-0 left-1/2 -translate-x-1/2'>
                        <motion.img 
                            src="https://assets.learntube.ai/files/New%20Landing%20Page/bigger-circle.png?updatedAt=1744727963586" 
                            className="w-full h-full" 
                            alt=""
                            animate={{ rotate: -360 }}
                            transition={{
                                repeat: Infinity,
                                duration: 12,
                                ease: "linear"
                            }}
                        />
                    </div>
                    <div className='z-10 w-[364px] h-[364.5px] absolute left-1/2 -translate-x-1/2' style={{
                        backgroundImage: 'linear-gradient(to right, rgba(13, 36, 54, 1) 0%, rgba(13, 36, 54, 0) 100%)'
                    }}>
                        
                    </div>
                </div>
                <div className="h-[164px] w-[135px] overflow-hidden relative">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={index}
                            initial={{ y: 100, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -120, opacity: 0 }}
                            transition={{ duration: 1 }}
                            className="absolute inset-0 text-[15px] text-[#83BEFF] flex items-center justify-center text-center"
                        >
                            {content[index]}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </div>
    )
}

export default DesktopHowItWorks